const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setRebatePortfolio1": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  